import { RevealOnScroll } from './motion/RevealOnScroll';
import { AmbientBackground } from './AmbientBackground';

export function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <section className="relative overflow-hidden pt-20 pb-16 sm:pt-28 sm:pb-20">
      <AmbientBackground />
      <RevealOnScroll className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {eyebrow && (
          <p className="mb-4 text-sm font-semibold uppercase tracking-wider text-indigo-300">{eyebrow}</p>
        )}
        <h1 className="text-4xl md:text-5xl font-bold text-zinc-100">{title}</h1>
        {subtitle && <p className="mt-5 text-lg text-zinc-400">{subtitle}</p>}
      </RevealOnScroll>
    </section>
  );
}
